<h2 mat-dialog-title>Kijelentkezés</h2>
<mat-dialog-content>
    <p>Biztosan ki szeretne jelentkezni?</p>
    <mat-checkbox [(ngModel)]="clearSelectedCeg">
        Kiválasztott cég törlése
    </mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Mégse</button>
    <button mat-flat-button color="primary" (click)="onConfirm()">Kijelentkezés</button>
</mat-dialog-actions>
